/**
 * Report whether the current route's own page controls the address bar.
 *
 * Detail views mount as a `modal` named view layered over their index page, so the
 * index keeps rendering underneath. While that is the case the modal route owns the
 * URL: an index rewriting it would stamp its own filter state onto the detail path
 * and drop query params the modal still needs.
 */
export function ownsUrl(route) {
  return !route.matched.some(record => Boolean(record.components?.modal));
}
